

export class featureGetSmoothNumbers {
    
    public static getSmoothNumbers( min,max: number, sliderWidth: number, numbers: number[]): number[] {
        let range: number = Math.abs(max - min);
        let maxShiftByValuePercent: number = 4;
        let maxShiftBySliderWidthPercent: number = 8;
        let maxShiftByValue: number = range * maxShiftByValuePercent / 100;
        let maxShiftBySliderWidth: number = (sliderWidth * maxShiftBySliderWidthPercent / 100) * (range / sliderWidth);
        let maxShift: number = Math.min(maxShiftByValue, maxShiftBySliderWidth);
        let smoothNumbers: number[] = [];
        numbers.forEach( (number: number) => {
            let number_min = Math.max( number - maxShift, min);
            let number_max = Math.min(number + maxShift, max);
            smoothNumbers.push(this._getBestSmoothNumber(number, number_min, number_max));
        });
        return smoothNumbers;
    }
    
    private static _getBestSmoothNumber( number: number, number_min: number, number_max: number): number {
        let bestSmoothNumber: number = number;
        let bestRank: number = 0;
        [10, 5, 2, 1, 0.1, 0.01].forEach( multiply1 => {
            [10, 100, 1000, 10000, 100000, 1000000, 100000000, 1000000000].forEach( multiply2 => {
                let divider : number = multiply1 * multiply2;
                let possibleDividedNumbers: number[] = [
                    Math.round(number / divider) - 1,
                    Math.round(number / divider),
                    Math.round(number / divider) + 1
                ];
                possibleDividedNumbers.forEach(possibleDividedNumber => {
                    let smoothNumber = possibleDividedNumber * divider;
                    if (smoothNumber < number_min) {
                        smoothNumber = number_min;
                    }
                    if (smoothNumber > number_max) {
                        smoothNumber = number_max;
                    }
                    if (this._getRank(smoothNumber, number, divider) > bestRank) {
                        bestSmoothNumber = smoothNumber;
                        bestRank = this._getRank(smoothNumber, number, divider);
                    }
                });
            })
        });
        return bestSmoothNumber;
    }
    
    private static _getRank( smoothNumber: number, number: number, divider: number): number {
        let rank: number = 0;
        if (smoothNumber % divider === 0) {
            rank += divider * 10;
        }
        rank =  rank - Math.abs(smoothNumber - number);
        return rank;
    }
    
}